import { useRoute } from '#app'
import { computed } from 'vue'

export const usePath = () => {
  const route = useRoute()

  return computed(() => {
    let p = route.path
    if (p === '/') return '/'
    p = p.endsWith('/') ? p : `${p}/`
    p = p.replace(/^\/admin\//, '/')
    return p
  })
}
